import React, { useState, useEffect, useRef } from "react";

import { Button,
    InputAdornment, 
    IconButton, 
    Modal,
    Container,
    Card,
    Stack, 
    TextField,
    Typography,
    Box,
} from '@mui/material';
import TimeIcon from '@mui/icons-material/AccessTime';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LocationIcon from '@mui/icons-material/LocationOnOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import LoadingButton from "@mui/lab/LoadingButton";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import AmenityEntityBlankComponent from "./amenity-entity-blank-component";
import config from '../../../hoa-config';
import '../../hoa-styles.scss';
import '../../municipalities/hoa-municipality-styles.scss';
import PDFsContainerComponent from "../../pdf-container-component/hoa-pool-access-form-pdf-container";
import dayjs from 'dayjs';
import { getDateOnly} from "../../../utility/get-formated-date";
import CustomDateField from "../../../Container/custom-date-field";
import SourceIDVerificationCard from "./common/SourceIDVerificationCard";
import AttachmentIcon from '@mui/icons-material/Attachment';
import useFieldDisabled from "../../../hooks/useFieldDisabled";

const filteredAmenityOptions = Object.keys(config.amenityIcons).filter(item => item !== 'Beache Access');

interface HoaEventProps {
    hoa: any;
    previousHoa: any;
    setCurrentHoa: any;
    updateHoaData: any;
    updateSelectedValues: any;
    hoaEvents: any;
    setHoaEvents: any;
    height: number;
    view: string;
    setState: any;
    state: any;
}

export default function HoaEventForm(props : HoaEventProps) {
    const {hoa, previousHoa, setCurrentHoa, updateHoaData, updateSelectedValues, hoaEvents, setHoaEvents, height, view, state, setState} = props;
    const { isHoaFieldDisabled } = useFieldDisabled();
    const [open, toggleOpen] = useState(false);
    const [eventOpen, setEventOpen] = useState(false);
    const [event, setEvent] = useState<any>({});
    const [toBeEditedEvent, setToBeEditedEvent] = useState<any>({});
    const [toBeDeleteEvent, setToBeDeleteEvent] = useState<any>({});
    const [toBeDeletedFile, setToBeDeletedFile] = useState<any>({})

    const handleEventClose = () => {
        setEventOpen(false);
    }

	const handleClose = () => {
		toggleOpen(false);
	};

    const handleEventOpen = () => {
        setEvent({
                address: "",
                eventDate: "",
                fromTime: "",
                newsLetterNotificationFiles: [],
                title: "",
                toTime: ""
            })
        setEventOpen(!eventOpen);
    }

    const handleEditEvent = (event: any) => {
        setEventOpen(!eventOpen);
        setToBeEditedEvent(event);
    }

    const handleEventDelete = (event: any) => {
        setToBeDeleteEvent(event)
        toggleOpen(!open);
    }

    return (
        <div style={{ width: "100%", height: props.height, borderRadius: "4px", fontSize: '20px' }}>
            <DeleteAttachmentComp
                open={open}
                handleClose={handleClose}
                setHoaEvents={setHoaEvents}
                toBeDeleteEvent={toBeDeleteEvent}
                setToBeDeleteEvent={setToBeDeleteEvent}
                state={state}
                setState={setState}
                event={event}
                setEvent={setEvent}
                setCurrentHoa={setCurrentHoa}
                toBeDeletedFile={toBeDeletedFile}
                setToBeDeletedFile={setToBeDeletedFile}
			/>
            <AddHoaEvent
                open={eventOpen}
                onClose={handleEventClose}
                view={view}
                state={state}
                setState={setState}
                toBeEditedEvent={toBeEditedEvent}
                setToBeEditedEvent={setToBeEditedEvent}
                toggleOpen={toggleOpen}
                deleteOpen={open}
                event={event}
                setEvent={setEvent}
                setToBeDeletedFile={setToBeDeletedFile}
                setHoaEvents={setHoaEvents}
            />
            <div style={{wordBreak:"break-all"}}>
                <div style={{margin: '24px 0px', paddingBottom: '14px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div className="sub-title-text">
                            HOA Events
                        </div>
                        <Button disabled={isHoaFieldDisabled('hoaEvents')} style={{borderColor:"#E8E8E8", color:"#3E3E3E"}} onClick={handleEventOpen} startIcon={<AddIcon color="primary"/>} variant="outlined">Add Event</Button>
                    </div>
                    {
                        Array.isArray(state?.hoaEvents) && state.hoaEvents.length > 0 ?
                        <>
                            {
                                state.hoaEvents.map((event: any, index: number) => (
                                    <Card
                                        key={index}
                                        variant="outlined"
                                        style={{ background: "#FAFAFA", marginTop: '24px'}}
                                        className="violation-card-container"
                                    >
                                        <Stack direction={"row"} justifyContent={'space-between'}>
                                            <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column'}}>
                                                {event.eventDate ?
                                                    <Typography style={{fontSize: '12px', paddingBottom: '10px',color:"#787878", fontWeight:"500"}}>{`${getDateOnly(event?.eventDate)} -  ${getDateOnly(event?.endDate)}|  ${event?.fromTime} - ${event?.toTime}`}</Typography>: null
                                                }
                                                <Typography style={{fontSize: '14px', color:"#3E3E3E", fontWeight:"500"}}>{event.title}</Typography>
                                            </div>
                                            <div style={{ display:'flex', alignItems:'center', justifyContent:'center'}}>
                                                <IconButton onClick={() => handleEditEvent(event)} disabled={isHoaFieldDisabled('hoaEvents')}>
                                                    <EditOutlinedIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleEventDelete(event)} disabled={isHoaFieldDisabled('hoaEvents')}>
                                                    <DeleteOutlineIcon />
                                                </IconButton>
                                            </div>
                                        </Stack>
                                        <Stack direction={"row"} mt={1} pb={"2px"} pt={"2px"} alignItems={"center"} borderBottom={'1px solid #E8E8E8'}>
                                        <div>
                                        <IconButton style={{fontSize:"14px", color:"#323232"}}>
                                            <LocationIcon/>
                                        </IconButton>
                                        </div>
                                        <span style={{fontSize: '12px', color:"#787878"}}>{event.address}</span>
                                        </Stack>
                                        <Stack direction={"row"} mt={1} mb={1} p={"2px"} alignItems={"center"} borderBottom={'1px solid #E8E8E8'}>
                                        <span style={{fontSize: '12px', color:"#787878", paddingBottom: '5px'}}>{event?.additionalInformation}</span>
                                        </Stack>
                                        {
                                            event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.length>0 ?
                                            <Stack direction={"row"} alignItems={"center"} >
                                                <div>
                                                    <IconButton>
                                                        <DescriptionIcon/>
                                                    </IconButton>
                                                </div>
                                                <span style={{fontSize: '12px'}}>Newsletter & Notification</span>
                                            </Stack> : null
                                        }
                                    </Card>
                                ))
                            }
                        </>
                        :
                        <AmenityEntityBlankComponent type={'hoaEvents'} title={'No Events Found'} subTitle={'Please click on Add Event to add Event to this HOA'}/>
                    }
                    
                </div>
            </div>
        </div>
    )
}

const DeleteAttachmentComp = ({
	open,
	handleClose,
    setHoaEvents,
    toBeDeleteEvent,
    setToBeDeleteEvent,
    state, 
    setState,
    event,
    setCurrentHoa,
    toBeDeletedFile,
    setEvent,
    setToBeDeletedFile
}: any) => {

	const [isLoading, setLoading] = useState(false);

	const handleDelete = async () => {
        if(Object.keys(toBeDeleteEvent).length){
            let tempState = {...state}
            let remainingHoaEvents = tempState.hoaEvents.filter((event: any) => event != toBeDeleteEvent);
            tempState.hoaEvents = remainingHoaEvents
            setState(tempState);
            setCurrentHoa(tempState)
            setHoaEvents(remainingHoaEvents);
            setToBeDeleteEvent({});
            handleClose();
            return;
        } else if(Object.keys(toBeDeletedFile).length) {
            let remainingHoaEventFiles = event.newsLetterNotificationFiles.filter((file: any) => file != toBeDeletedFile);
            setEvent({...event, newsLetterNotificationFiles: remainingHoaEventFiles})
            setToBeDeletedFile({});
            handleClose();
            return;
        }
        setLoading(false);
	};
	const onClose = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Container className="modal-container-style-amenity">
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}


const AddHoaEvent = ({
    open, 
    onClose,
    view,
    state,
    setState,
    toBeEditedEvent,
    setToBeEditedEvent,
	toggleOpen,
    deleteOpen,
    event,
    setEvent,
    setToBeDeletedFile,
    setHoaEvents
}: any) => {
    const [checkError, setCheckError] = useState(false);
    const [sourceFileInfo, setSourceFileInfo] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(toBeEditedEvent){
            setEvent(toBeEditedEvent)
        }
    },[toBeEditedEvent])

    useEffect(() => {
        if(event.newsLetterNotificationFiles){
            setSourceFileInfo(event.newsLetterNotificationFiles || [])
        }
    }, [event])

    const handleChange = (value: any, key: string) => {
        setEvent({...event, [key]: value})
    }

    const onSaveClick = () => {
        setCheckError(true);
        if (!event.title || !event.address) return;
    
        let tempState = {
            ...state,
            hoaEvents: state.hoaEvents ?? []
        };
        
        let index = tempState.hoaEvents.indexOf(toBeEditedEvent);
        
        if (index >= 0) {
            tempState.hoaEvents[index] = event;
        } else {
            tempState.hoaEvents.push(event);
        }
        
        setState(tempState);
        setHoaEvents(tempState.hoaEvents)
        setEvent({});
        setToBeEditedEvent({});
        setCheckError(false);
        onClose();
    };
    
    

    const deleteClick = (file: any) => {
		toggleOpen(!deleteOpen);
        setToBeDeletedFile(file)
	}
    const handleClose =()=>{
        setCheckError(false); 
        setToBeEditedEvent({});
        onClose();
    }

    let uploadedFiles = event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.filter((file: any) => file.fileName);

    const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: '',
			sourceIdType: ''
		}
		setSourceFileInfo([newSource, ...sourceFileInfo]);
	}

    const deleteSourceDocument = (index: number) => {
        let tempState = [...sourceFileInfo];
        tempState = tempState.filter((item, idx) => idx !== index);
        setSourceFileInfo(tempState);
        setEvent({...event, newsLetterNotificationFiles: tempState});
    }
    

	const handleSourceFile = (e: any, index: number) => {
		const {name, value} = e.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === 'files' && value.length > 0) {
			tempState[index]['isVerified'] = true;
        } else if (name === 'files' && value.length == 0) {
			tempState[index]['isVerified'] = false;
        }
        setSourceFileInfo(tempState);
        setEvent({...event, newsLetterNotificationFiles: tempState});
	}

    const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified || item.url);

    return(
        <Modal open={open} onClose={handleClose}>
			<Container className="modal-container-style-amenity2" disableGutters>
            <div className="modal-wrapper-amenity">
            <Stack direction={"row"} position={"sticky"} zIndex={9999999} top={0} sx={{background: "#EFF4FC"}} justifyContent={"space-between"} alignItems={"center"} pl={"24px"} pr={"24px"} height={72} borderBottom={"1px solid #E8E8E8"}>
                <Box display={"flex"} alignItems={"center"}>
                    <p style={{color: '#3E3E3E', fontSize:"20px", fontWeight:"500", fontFamily:"roboto"}}>{Object.keys(toBeEditedEvent).length ? `Update Event` : `Add Event`}</p>
                </Box>
                <Box >
                    <IconButton onClick={handleClose}>
                        <CloseOutlinedIcon sx={{color:"#2F2F2F"}} />
                    </IconButton>
                </Box>
            </Stack>	
            <Stack style={{padding:"6px 24px 0 24px"}}>
                <Stack>
                    <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                        <TextField style={{ width: "100%" }} variant="standard" label="Title" name="title" value={event.title || ""} required
                            onChange={(e)=>{handleChange(e.target.value, "title")}}  InputLabelProps={{style:{fontSize:"14px"}}}
                            error={checkError && !state.title} InputProps={{style:{ padding:"7px 0px"}}}/>
                    </div>
                    <div style={{  marginTop: "24px"}}>
                        <TextField style={{ width: "100%" }} variant="standard" label="Address" name="address"  value={event.address || ""} required
                            onChange={(e)=>{handleChange(e.target.value, "address")}} InputLabelProps={{style:{fontSize:"14px"}}}
                            error={checkError && !state.address} InputProps={{style:{ padding:"7px 0px"}}}/>
                    </div>
                    <div style={{  marginTop: "24px"}}>
                        <TextField style={{ width: "100%" }} variant="standard" label="Additional Information" name="additionalInformation"  value={event.additionalInformation || ""} required
                            onChange={(e)=>{handleChange(e.target.value, "additionalInformation")}} InputLabelProps={{style:{fontSize:"14px"}}}
                            error={checkError && !state.additionalInformation} InputProps={{style:{ padding:"7px 0px"}}}/>
                    </div>

                    <div style={{display:"flex", justifyContent: "space-between", paddingBottom:"24px", borderBottom: "1px solid #E8E8E8"}}>
                    <CustomDateField 
                        label="Start Date"
                        error={false}
                        variant="standard"
                        style={{width: '45%', padding: "10px 0px", marginTop: "24px"}}
                        value={dayjs(event.eventDate || null)}
                        handleChange={(value: any)=> {handleChange(value, "eventDate")}}
                    />
                    <CustomDateField 
                        label="End Date"
                        error={false}
                        variant="standard"
                        style={{width: '45%', padding: "10px 0px", marginTop: "24px"}}
                        value={dayjs(event.endDate || null)}
                        handleChange={(value: any)=> {handleChange(value, "endDate")}}
                    />
                    </div>
                    
                    <div className="sub-title-text-2" style={{margin:"12px 0px"}}>Time</div>
                    <div style={{display:"flex", paddingBottom:"24px", borderBottom: "1px solid #E8E8E8"}}>
                    <TextField style={{ width: "35%", marginRight:"24px" }} variant="standard" type="time" label="From" name="fromTime" value={event?.fromTime || ""}
                            onChange={(e)=>{handleChange(e.target.value, "fromTime")}}  InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                        InputProps={{
                            style:{ padding:"7px 0px"},
                            endAdornment: (
                                <InputAdornment position="end">
                                    <TimeIcon />
                                </InputAdornment>
                        )}}/>
                    <TextField style={{ width: "35%"}} variant="standard" type="time" label="To" name="toTime" value={event?.toTime ||""}
                            onChange={(e)=>{handleChange(e.target.value, "toTime")}}  InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                        InputProps={{
                            style:{ padding:"7px 0px"},
                            endAdornment: (
                                <InputAdornment position="end">
                                    <TimeIcon />
                                </InputAdornment>
                        )}}/>
                    </div>
                    <Stack>
                        <div className="sub-title-text-2" style={{margin:"24px 0px"}}>Newsletter & Notification</div>
                        {
                            uploadedFiles?.length > 0 ?
                            <>
                            <p className="helperText" style={{fontWeight:"bold"}}>Uploaded File :</p>
                            {
                                Array.from(uploadedFiles).map((file : any, index: number)=>{
                                    if(file?.fileName){
                                        return <PDFsContainerComponent document={`newsLetterNotificationFiles`} deleteClick={() => deleteClick(file)} view={view} key={index} file={file} />
                                    }
                                })
                            }
                            </>
                            : ''
                        }
                    </Stack>
                    <Stack direction={'row'} alignItems='center' spacing={2} paddingTop="10px" paddingBottom="10px">
                    <Button
                    	startIcon={<AttachmentIcon color="primary" />}
                    	variant="outlined"
                    	disabled={!isAllVerified}
                    	onClick = {addNewSourceDocument}
                    >
                    	Attach Document
                    </Button>
                    </Stack>
                    <Stack>
                    {sourceFileInfo.filter((sourceFile: any) => !sourceFile.url).map((item: any, index: any) => ( 
                    <SourceIDVerificationCard
                        key={index}
                        index={index}
                        parentIndex={index}
                        item={item}
                        loading={loading}
                        setLoading={setLoading}
                        handleSourceFile={handleSourceFile}
                        handleDeleteCard={deleteSourceDocument}
                    />
                    ))}
                    </Stack>

                </Stack>
                </Stack>
					<Stack
						style={{ padding: "24px",border: "1px solid #E8E8E8" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                    <>
                        <Button onClick={() => {onClose();setCheckError(false); setToBeEditedEvent({})}} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={onSaveClick} variant="contained" style={{color: '#fff', backgroundColor: '#3576E5'}}>
                            Save
                        </Button>
                    </>
					</Stack>
            </div>
			</Container>
		</Modal>
    )
}


